// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addMember{
    font-size: 35px;
    position: relative;
    left: 25vw;
    padding-top: 35px;
    color: black;
    opacity: 70%;
}
.groupAddIcon{
    color: darkgray;
    position: relative;
    top: 8px;
    left: 5px;
}
.members_list{
    padding-top: 20px;
}

.group-btn-section{
    margin-bottom: 10px;
    /* background-color: antiquewhite; */
    font-size: 22px !important;
    font-weight: 700;
    opacity: 70%;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GroupsSection/CreateGroup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".addMember{\n    font-size: 35px;\n    position: relative;\n    left: 25vw;\n    padding-top: 35px;\n    color: black;\n    opacity: 70%;\n}\n.groupAddIcon{\n    color: darkgray;\n    position: relative;\n    top: 8px;\n    left: 5px;\n}\n.members_list{\n    padding-top: 20px;\n}\n\n.group-btn-section{\n    margin-bottom: 10px;\n    /* background-color: antiquewhite; */\n    font-size: 22px !important;\n    font-weight: 700;\n    opacity: 70%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
